import  { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import  Header  from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

function CodeOfConduct() {
      const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

    return (
        <>
            <div className="antialiased light-vz circle-v ">
                <Header events={events} />
                <h1 className='spacer-section'></h1>
                
                {/* Code of Conduct Section */}
                <section className="general-text">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                         
                        <div className="sec-title white-heading-text">
                            <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-file fa-stack-1x"></i></span></span>
                            <h3 className="wow fadeInRight" data-wow-duration="500ms">Code of Conduct</h3>
                        </div> {/* <!--sec-title end--> */}
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="conduct-content">
                                    <p>
                                        <strong>BSidesBangalore</strong> is dedicated to providing an awesome event for all communities and community members and this means a harassment-free conference experience for everyone. We do not tolerate harassment in any form and we expect all of our conference's participants to abide by our common ethos defined below in our "Code of Conduct Policy: Simple Expectations".
                                    </p>
                                    <br/>
                                    <h2>Simple Expectations:</h2>
                                    <ul>
                                        <li><strong>Be an ADULT</strong></li>
                                        <li>Be respectful, polite, honourable, tolerant and a positive contributor to our event and society</li>
                                        <li>Do not be crass, rude, ignorant or demeaning</li>
                                        <li>Do unto others as you would have them do unto you</li>
                                    </ul>
                                    <br/>
                                    
                                    <h2>Enforcement and Consequences:</h2>
                                    <ul>
                                        <li>If an individual believes this Code of Conduct is in violation, we ask them to make the organizers aware of the issue so it can be remediated</li>
                                        <li>Conference participants violating these simple rules may be sanctioned or expelled from the conference without a refund at the sole discretion of the conference organizers</li>
                                    </ul>
                                    <br></br>
                                    <h2>Liability:</h2>
                                    <p>
                                        BSidesBangalore is not responsible for any actions of attendees, speakers, volunteers or other participants.
                                    </p>
                                    
                                    <p className="mt-4">
                                        <em>"BSidesBangalore Code of Conduct inspired by BSidesVancouver Code of Conduct"</em>
                                    </p>
                                     <br/> <br/> <br/> <br/> <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
               <MainWebFooter  />
                <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
            </div>
        </>
    );
}

export default CodeOfConduct;